module.exports = __webpack_public_path__ + "img/023.55e95805.png";